import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=0e4c383c"
import script from "./ActivityItem.vue?vue&type=script&lang=ts"
export * from "./ActivityItem.vue?vue&type=script&lang=ts"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=0e4c383c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports